export const EXCEL_CASE_ACTIONS = {

    EXCEL_CASE_SEARCH_SUCCESS: 'EXCEL_CASE_SEARCH_SUCCESS',
    
    EXCEL_CASE_SEARCH_ERROR: 'EXCEL_CASE_SEARCH_ERROR',
  
    EXCEL_CASE_SEARCH: 'EXCEL_CASE_SEARCH',
};

export const excelCaseSearchAction = (payload) => ({
    type: EXCEL_CASE_ACTIONS.EXCEL_CASE_SEARCH,
    ...payload,
});

export default {
    EXCEL_CASE_ACTIONS,
    excelCaseSearchAction,
};
